import { render } from "./NavBreadcrumb.vue?vue&type=template&id=093068c5&scoped=true"
const script = {}

import "./NavBreadcrumb.vue?vue&type=style&index=0&id=093068c5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-093068c5"]])

export default __exports__